import { render, staticRenderFns } from "./DeliveryItem.vue?vue&type=template&id=570d3653&"
import script from "./DeliveryItem.vue?vue&type=script&lang=js&"
export * from "./DeliveryItem.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryItem.vue?vue&type=style&index=0&id=570d3653&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports